import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';

import type {
  StatusesType,
  StatusType,
} from '@app/components/RecordModal/components/RecordDetails/types';

import '@app/components/RecordModal/components/RecordDetails/styles/Statuses.desktop.scss';
import '@app/components/RecordModal/components/RecordDetails/styles/Statuses.tablet.scss';

const Status: StatusType = ({
  label,
  icon,
  color,
  selected = false,
  disabled = false,
  status,
  onSelect,
}) => (
  <Button
    htmlType="button"
    icon={<FontAwesomeIcon icon={icon} className="icon" />}
    className="statuses__button"
    style={{
      borderColor: color,
      backgroundColor: selected ? color : 'transparent',
      color: selected ? 'white' : color,
      opacity: disabled ? 0.3 : 1,
    }}
    data-testid={`record-status-${status}`}
    disabled={disabled}
    onClick={() => {
      if (disabled) return;
      onSelect(status);
    }}
  >
    {label}
  </Button>
);

export const Statuses: StatusesType = ({
  selectedItem,
  onSelect,
  items,
  disabled = false,
}) => (
  <div className="statuses__wrapper">
    {items.map(({ id, ...props }) => (
      <Status
        key={id}
        id={id}
        selected={selectedItem === props.status}
        onSelect={onSelect}
        disabled={disabled}
        {...props}
      />
    ))}
  </div>
);
